import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";

import { theme } from '../../../themController';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { baseStyles, baseColors } from "../../baseStyles";
import {
  getGIZprivileges, updateEmployee
} from "../../general_functions/employeeFunctions";
import UserRoles from "./userRoles";
import Fab from '@material-ui/core/Fab';
import SearchIcon from '@material-ui/icons/Search';

export default class UpdateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      passwordChecker: true,
      gizPrivileges: [],
      id: '',
      _id: 0
    };
  }

  cleanFormHandler(){
    this.setState({
      username: '',
      email: '',
      gizPrivileges: [],
    })
  };

  handleSaveButton(e) {
    e.preventDefault();
    const state = this.state;
    //Check if form's files are not empty.
    if (
      state.userName == "" ||
      state.email == ""
    ) {
      this.props.handleSnackbar(
        "Fiels should not empty"
      );
      return;
    }

    let rolesId = [];
    state.gizPrivileges.map((role, index) => {
      rolesId.push(parseInt(role.sortNO));
    });

    let data = {
      username: state.username,
      email: state.email,
      state: 1,
      _id: state._id
    };

    updateEmployee(data, res => {
      if (res.success) {
        this.props.handleSnackbar(
          "User has been updated succesfuly!"
        );
      } else {
        this.props.handleSnackbar(
          "This user is already exist, please chnage your info and try again!"
        );
      }
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handelUserName = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  handleUserSearch(e) {
    let { searchUser } = this.state;
    this.props.users.map(user => {
      if (user.username == searchUser) {
        this.setState({
          ["username"]: user.username,
          ["email"]: user.email,
          ["_id"]: user._id,
        })
        this.handlerPrivilege(user);
        return;
      }
    });
  }

  handlerPrivilege(user) {
    let defaultPrivileges = getGIZprivileges();
    let newRoles = [];
    for ( let i = 0; i < user.roles.length; i++){
      for ( let j = 0; j < defaultPrivileges.length; j++){
        if ( defaultPrivileges[j].sortNO == user.roles[i] ) {
          defaultPrivileges[j].checked = true;
          newRoles.push(defaultPrivileges[j])
        } else {
        }
      }
    }

    this.setState({
     gizPrivileges: newRoles,
      id: user.id
    })
  }

  cleanPrivilege() {
    let newRoles = [];
    let defaultPrivileges = getGIZprivileges();

    for ( let j = 0; j < defaultPrivileges.length; j++){
      defaultPrivileges[j].checked = false;
      newRoles.push(defaultPrivileges[j])
    }

    this.setState({
     gizPrivileges: newRoles,
    })
  };

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div style={{ padding: "0 1.8em" }}>
          <div>
            <h3 style={{
              color: baseColors.bgBlue,
              paddingTop: 24}}>
              Update user by Username
            </h3>
          </div>
          <div>
            <div>
              <TextField
                style={baseStyles.textField}
                label="Search username"
                value={this.state.searchUser}
                onChange={this.handelUserName('searchUser')}
              />
              <Fab color="primary" aria-label="Search"
                onClick={this.handleUserSearch.bind(this)}
              >
                <SearchIcon  />
              </Fab>
            </div>
            <form>
              <div>
                <TextField
                  style={baseStyles.textField}
                  label="Username"
                  value={this.state.username}
                  onChange={this.handleChange('userName')}
                  defaultValue=" "
                  required
                />
                <TextField
                  style={baseStyles.textField}
                  value={this.state.email}
                  onChange={this.handleChange('email')}
                  defaultValue="..@...com"
                  type="email"
                  label="Email"
                />
              </div>
              <br/>
              {/* <div>
                <UserRoles
                  roleTitle={"User privileges"}
                  defaultRoles={this.state.gizPrivileges}
                  privileges={getGIZprivileges()}
                  getAllUserPrivilege={array =>
                    this.setState({ gizPrivileges: array })
                  }
                />
              </div> */}
              <div>
                <br />
                <Button
                  style={baseStyles.minButton}
                  color="primary"
                  onClick={this.handleSaveButton.bind(this)}>
                  Save
                </Button>
                <Button
                  style={baseStyles.minButton}
                  color="secondary"
                  onClick={this.cleanFormHandler.bind(this)}>
                  Clear
                </Button>
              </div>
            </form>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
